import PropTypes from 'prop-types'
import { useHelpPopup } from './hooks'

HelpPopup.propTypes = {
  slug: PropTypes.string.isRequired,
  active: PropTypes.bool,
  delay: PropTypes.number
}

export default function HelpPopup({ slug, active = true, delay = 2000 }) {
  useHelpPopup(slug, active, delay)

  return null
}
